import React from 'react'
import Quotes from 'pages/www/components/quotes/Quotes'
import SectionType from 'models/types/ts/sectionType'
import Wrapper from '../wrapper/Wrapper'
import style from './MediaQuotes.module.scss'

interface Props {
    section: SectionType
}

const MediaQuotes = ({ section }: Props): JSX.Element => {
    if (!section?.contentCollection?.items?.length) {
        return null
    }

    const { contentCollection } = section

    return (
        <Wrapper>
            <div className={style.mediaQuotes}>
                <Quotes content={contentCollection.items} />
            </div>
        </Wrapper>
    )
}

export default MediaQuotes
